import BarberNav from './components/nav';
import HomeHero from './components/home';
import HaircutGallery from './components/galery';
import MenuSection from './components/services';
import ProductCarousel from './components/products';
import Footer from './components/footer';
import About from './components/AboutMe';

function App() {
  return (
    <div className="App">
      <BarberNav />
      <HomeHero />
      <About />
      <HaircutGallery/>
      <MenuSection />
      <ProductCarousel />
      <Footer />
    </div>
  );
}

export default App;
